import { FontLoader, Vector3, TextBufferGeometry } from "three";
import React, { useCallback, useRef } from "react";
import { useLoader, useFrame } from "react-three-fiber";
import usePromise from "react-promise-suspense";
import lerp from "lerp";
import store from "../../../store";

//Rendered TextBufferGeometry

const Text =
  ({ 
    children, 
    size = 1, 
    left, 
    right, 
    top, 
    bottom, 
    color = "white", 
    opacity = 1, 
    height = 10, 
    layers = 0, 
    font = "/Josefin_Sans/JosefinSans_Regular.json",
    ...props 
  }) => {

  const data = useLoader(FontLoader, font)
  const geom = usePromise(() => new Promise(res => res(new TextBufferGeometry(children, { font: data, size: 1, height, curveSegments: 32}))), [children])
  const onUpdate = useCallback(
    self => {
      const box = new Vector3()
      self.geometry.computeBoundingBox()
      self.geometry.boundingBox.getSize(box)
      self.position.x = left ? 0 : right ? -box.x : -box.x / 2
      self.position.y = top ? 0 : bottom ? -box.y : -box.y / 2
    },
    [left, right, top, bottom]
  )

  const ref = useRef()
  let last = store.top.current
  useFrame(() => {
    ref.current.shift = lerp(ref.current.shift, (store.top.current - last) / 100, 0.8)
    last = store.top.current
  })

  return (
    <group {...props} scale={[size, size, 0.1]}>
      <mesh geometry={geom} onUpdate={onUpdate} frustumCulled={false} receiveShadow castShadow>
        <customMaterial ref={ref} attach="material" color={color} transparent opacity={opacity} />
      </mesh>
    </group>
  )
};

export { Text };